import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Runs on every route change to:
 *  1. Reset window + main scroll (prevents "blank page below the fold"
 *     when leaving full-viewport pages like /chat).
 *  2. Force-clear any residual body/html scroll-locks left behind by
 *     Radix dropdowns/dialogs whose cleanup was interrupted by the
 *     navigation (root cause of the recurring blank-screen on menu
 *     click while a chat window was open).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      // 1. Reset scroll on every scroll surface
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      const main = document.querySelector("main");
      if (main) main.scrollTop = 0;

      // 2. Defensively clear body/html locks that Radix (or other
      //    portals) may have left behind. If a dropdown is open when
      //    the user clicks a nav link, React unmounts the trigger
      //    before Radix's outside-click cleanup runs — leaving
      //    `overflow: hidden` and `pointer-events: none` on <body>.
      const bodyStyle = document.body.style;
      const htmlStyle = document.documentElement.style;
      if (bodyStyle.overflow === "hidden") bodyStyle.overflow = "";
      if (bodyStyle.pointerEvents === "none") bodyStyle.pointerEvents = "";
      if (bodyStyle.paddingRight) bodyStyle.paddingRight = "";
      if (htmlStyle.overflow === "hidden") htmlStyle.overflow = "";
      // Remove Radix's own data-attribute lock flags
      document.body.removeAttribute("data-scroll-locked");
      document.documentElement.removeAttribute("data-scroll-locked");
    } catch { /* ignore */ }
  }, [pathname]);
  return null;
}
